import { createReducer, on } from '@ngrx/store';
import { loadEnvironmentSuccessAction } from './environment.actions';

export interface State {
	[key: string]: any;
}

const initialState: State = {};

export const environmentReducer = createReducer(
	initialState,
	on(loadEnvironmentSuccessAction, (_, { environment }): State => ({
		...environment,
	}))
);
